// index

let dt_index = null;
let dt_microsites = null;
let dt_users = null;

export function index(params){

    dt_index = $('#groups_table').DataTable({
        ajax: {
            url: $('#groups_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_groups_actions },
            { data: 'name', orderable: true, searchable: true },
            { data: 'roles', orderable: true, searchable: true },
        ],
        order: [[2, 'asc']],
    });

    dt_index.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_groups"]').click(batch_delete_group);
        window.forms.init();
    });
}

export function filter_microsites(data){

    let results = $.map(data.results, function(obj, index) {
        return { 
            id: obj.id, 
            text: obj.name,
            result: obj.name + '<small class="d-block font-weight-light">' + obj.url + "</small>"
        };
    });

    return {
        results: [{id: 0, text: '&nbsp;'}].concat(results) 
    };

}

function batch_delete_group(){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['admin.groups.batch_delete'];
    
    let groups_id = [];
    $.each(rows_selected, function(index, rowId){
        groups_id.push(rowId);
    });
    
    if(groups_id.length == 0){

        window.messages.error(__('No has seleccionado ningún grupo'));

    } else {

        const title = __('Eliminar grupos');
        const text = 
            trans_choice('{1} Estás a punto de eliminar un grupo.|[2,*] Estás a punto de eliminar :count grupos.', groups_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    for(let user_id of groups_id){
                        formData.append('groups_id[]', user_id);
                    }

                    window.forms.post(route, formData);

                }, 
                _ => {}
            );

    }

}

function render_groups_actions(data, type, row){

    const url_info = ($("#groups_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;

}

export function index_reload(){
    
    dt_index.ajax.reload();

}

export function index_force_reload(){

    dt_index.column(0).checkboxes.deselectAll();
    dt_index.ajax.reload();

}

// show

export function show(){
    init_permissions();
    init_users();
}

function init_permissions() {
    // datatable group_microsites_table
        
    dt_microsites = $('#group_microsites_table').DataTable({
        ajax: {
            url: $('#group_microsites_table').attr('url'),
        },
        columns: [
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_groups_microsite_actions },
            { data: 'name', orderable: true, searchable: true },
            { data: 'dominio', orderable: true, searchable: true },
            { data: 'roles', orderable: false, searchable: true },
        ],
        order: [[1, 'asc']],
    });
}

function render_groups_microsite_actions(data, type, row) {
    const url_info = ($("#group_microsites_table").attr('url_info') ?? '').replace('#', row.subject_id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;
}

function init_users() {
    // datatable group_users_table
        
    dt_users = $('#group_users_table').DataTable({
        ajax: {
            url: $('#group_users_table').attr('url'),
        },
        columns: [
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_groups_user_actions },
            { data: 'username', orderable: true, searchable: true },
            { data: 'name', orderable: true, searchable: true },
            { data: 'roles', orderable: false, searchable: true },
        ],
        order: [[1, 'asc']],
    });
}

function render_groups_user_actions(data, type, row) {
    const url_info = ($("#group_users_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;
}

export function filter_users(data){

    return {
        results: $.map(data.results, function(obj, index) {
            let user = obj.username + '<small class="d-block font-weight-light">' + obj.name + ' ' + (obj.surname != null ? obj.surname : '') + "</small>";
            return { 
                id: obj.id,
                text: obj.username,
                result: user
            };
        })
    };
}
